//create ACTUAL FUNCTIONS, with FuncitonalNaming
//goddamn with immuatabilty bull

import produce from 'immer'


var items = [
	{
		mainName: "hello!",
		content: [
		{text: "Add a thing to do", isDone: false},
		{text: "Click on it when done", isDone: true},
		{text: "Use clear to start a new list", isDone: false}]
	}
]

//damn, LocalStorage? Give me a break..INIT and LOADING
if (localStorage.getItem('myData') == null) {
	localStorage.setItem('myData',JSON.stringify(items))
} else {
	items = JSON.parse(localStorage.getItem('myData'))
}


const listReducer = (state = items, action) => {
	switch(action.type) {
		case "TOGGLE":
			const newState = produce(state, draftState => {
			    draftState[action.main].content[action.id].isDone = !draftState[action.main].content[action.id].isDone
			})

			return newState;

		case "ADD":
			if (action.text !== '') {
				const newState2 = produce(state, draftState => {
					draftState[action.main].content.push({text: action.text,isDone:false})
					
				})
				return newState2
			} else {
				return state;
			}


		case "CLEAR":
			const newState3 = produce(state, draftState => {
				draftState[action.main].content = []
			})

			return newState3;

		case "SAVE":
			localStorage.setItem("myData",JSON.stringify(state))
			return state;

		case "ADD_MAIN":
			const newState4 = produce(state,draftState => {
				draftState.push({
					mainName: action.name,
					content: [
					{text: "Add a thing to do", isDone: false}]
				})
			})
			return newState4;

		default:
			return state;
	}
}


export default listReducer